
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("15ApQ", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0cb2818047415aec$export$6503ec6e8aabbaf; }, function (v) { return $0cb2818047415aec$export$6503ec6e8aabbaf = v; });
var $0cb2818047415aec$export$6503ec6e8aabbaf;
var $0cb2818047415aec$export$f7ad0328861e2f03;
"use strict";
var $0cb2818047415aec$var$mapping = new Map();
function $0cb2818047415aec$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0cb2818047415aec$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0cb2818047415aec$var$resolve(id) {
    var resolved = $0cb2818047415aec$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0cb2818047415aec$export$6503ec6e8aabbaf = $0cb2818047415aec$var$register;
$0cb2818047415aec$export$f7ad0328861e2f03 = $0cb2818047415aec$var$resolve;

});

var $d8adda7a87bba364$exports = {};

(parcelRequire("15ApQ")).register(new URL("", import.meta.url).toString(), JSON.parse('["6cgRs","index.bdbb41a3.js","lb59P","1.4b4d4b64.png","eNYbx","2.50e6e306.png","eEnyN","3.d5393261.png","gyNdJ","4.89729799.png","jIlXw","5.fa7fdba0.png","bGh8s","6.e32653c5.png","b3qss","7.716383dd.png","6JBfW","8.26b4c27b.png","jjZCu","9.f733ee91.png","hH1l0","10.e000c45a.png","k4RCG","11.2620c7ca.png","i9d0G","12.e56e04fc.png","3UfwQ","13.042e43b8.png","jR9ab","14.b19e847c.png","eGpJg","15.9e75e782.png","2POkm","16.431d4a37.png","64VCV","17.f4d6dc6f.png","fqX6N","18.87b3fb99.png","bssJY","19.26e9cd2f.png","3CxLi","20.d979a9c3.png","flch1","21.f8abd812.png","lQIDx","22.a4f11bf1.png","2ws4J","23.a230dcd1.png","iknSY","24.bf1c7797.png","ba05o","25.600ed89f.png","8dbHO","26.80b1524f.png","50mC6","27.9cf10421.png","4N3ZY","28.7ed5edc7.png","i4fdu","29.6b695a98.png","grIKO","30.38e4e9ab.png","hUnIk","31.bed4a148.png","eJLU3","32.0b9fa628.png","8ggco","33.b8130304.png","iix0w","34.44c0618f.png","ftDXK","35.2c63ac43.png","8glhU","36.efe792db.png","9kzbA","37.7e79ebd8.png","aGYJm","38.bc3e4804.png","cnCrw","39.91d3567c.png","cDOo6","40.da18d44e.png","gG7dU","41.416df1c7.png","43VP6","42.3a34dc1f.png","7GnxL","43.5ba578ad.png","ku5tX","44.05096ed2.png","2Ilfd","45.4037bc25.png","3p7Bn","46.d77eb262.png","4ARPv","47.a3c5818a.png","2aXUV","48.907e0e56.png","cYDJH","49.53f70f63.png","fpVvK","50.fcb823af.png","lxQQk","51.5e0d2f66.png","5Ya0K","52.64ff298f.png","bzYYH","53.0b398a42.png","8qnzP","54.d728ffac.png","1balf","55.153730f8.png","dnpGa","56.b65ff898.png","k3uLO","57.a7099aa7.png","ccr75","58.8fae3ad2.png","8kFcB","59.1bd548ba.png","01e9l","60.65ae3232.png","a6cWX","61.8dae416a.png","664VX","62.b1fdfcff.png","25hov","63.925d6784.png","flJxw","64.9783d915.png","hu2GI","65.6b146544.png","48LGG","66.77e608a2.png","lJJmv","67.ede302b3.png","8rQdm","i0.9ebb77d9.png","81GxD","i1.5d533fa9.png","icQLP","i2.3e0a7ae3.png","4Duvr","i4.08f436fc.png"]'));

var $cd17f8f7b228f5ad$exports = {};
$cd17f8f7b228f5ad$exports = new URL("1.4b4d4b64.png", import.meta.url).toString();


var $1eb94315d280b418$exports = {};
$1eb94315d280b418$exports = new URL("2.50e6e306.png", import.meta.url).toString();


var $f2912ec5cfa6e8ae$exports = {};
$f2912ec5cfa6e8ae$exports = new URL("3.d5393261.png", import.meta.url).toString();


var $eaf669eb63be91b5$exports = {};
$eaf669eb63be91b5$exports = new URL("4.89729799.png", import.meta.url).toString();


var $5887d3739f57db9f$exports = {};
$5887d3739f57db9f$exports = new URL("5.fa7fdba0.png", import.meta.url).toString();


var $e86a9148c069d268$exports = {};
$e86a9148c069d268$exports = new URL("6.e32653c5.png", import.meta.url).toString();


var $bce268fba41a3d1a$exports = {};
$bce268fba41a3d1a$exports = new URL("7.716383dd.png", import.meta.url).toString();


var $daf3bf220f8340fe$exports = {};
$daf3bf220f8340fe$exports = new URL("8.26b4c27b.png", import.meta.url).toString();


var $ef1ec34a82d15ba0$exports = {};
$ef1ec34a82d15ba0$exports = new URL("9.f733ee91.png", import.meta.url).toString();


var $d01013695c865a60$exports = {};
$d01013695c865a60$exports = new URL("10.e000c45a.png", import.meta.url).toString();


var $945c8cd5f1c78549$exports = {};
$945c8cd5f1c78549$exports = new URL("11.2620c7ca.png", import.meta.url).toString();


var $30f88c6cad6edf48$exports = {};
$30f88c6cad6edf48$exports = new URL("12.e56e04fc.png", import.meta.url).toString();


var $7a38680b781c159a$exports = {};
$7a38680b781c159a$exports = new URL("13.042e43b8.png", import.meta.url).toString();


var $a473f175886ac973$exports = {};
$a473f175886ac973$exports = new URL("14.b19e847c.png", import.meta.url).toString();


var $fef5cadb447aaea8$exports = {};
$fef5cadb447aaea8$exports = new URL("15.9e75e782.png", import.meta.url).toString();


var $e084c2e42eb4e3bb$exports = {};
$e084c2e42eb4e3bb$exports = new URL("16.431d4a37.png", import.meta.url).toString();


var $ba8b68aeb0eb0313$exports = {};
$ba8b68aeb0eb0313$exports = new URL("17.f4d6dc6f.png", import.meta.url).toString();


var $ef1d521155efbb18$exports = {};
$ef1d521155efbb18$exports = new URL("18.87b3fb99.png", import.meta.url).toString();


var $a40fc182aab17671$exports = {};
$a40fc182aab17671$exports = new URL("19.26e9cd2f.png", import.meta.url).toString();


var $edc9746367d9e7ed$exports = {};
$edc9746367d9e7ed$exports = new URL("20.d979a9c3.png", import.meta.url).toString();


var $44f0c51ffb229d0c$exports = {};
$44f0c51ffb229d0c$exports = new URL("21.f8abd812.png", import.meta.url).toString();


var $bdd9029b7704941a$exports = {};
$bdd9029b7704941a$exports = new URL("22.a4f11bf1.png", import.meta.url).toString();


var $124caf38706a7b68$exports = {};
$124caf38706a7b68$exports = new URL("23.a230dcd1.png", import.meta.url).toString();


var $1007f69132666c34$exports = {};
$1007f69132666c34$exports = new URL("24.bf1c7797.png", import.meta.url).toString();


var $dda08551c41d2872$exports = {};
$dda08551c41d2872$exports = new URL("25.600ed89f.png", import.meta.url).toString();


var $61f5aad62f8b5191$exports = {};
$61f5aad62f8b5191$exports = new URL("26.80b1524f.png", import.meta.url).toString();


var $112772afac2d1763$exports = {};
$112772afac2d1763$exports = new URL("27.9cf10421.png", import.meta.url).toString();


var $a31d927b9b9aa674$exports = {};
$a31d927b9b9aa674$exports = new URL("28.7ed5edc7.png", import.meta.url).toString();


var $5d545cead6abf56d$exports = {};
$5d545cead6abf56d$exports = new URL("29.6b695a98.png", import.meta.url).toString();


var $5ce41163fe4d0f61$exports = {};
$5ce41163fe4d0f61$exports = new URL("30.38e4e9ab.png", import.meta.url).toString();


var $948dffd8c072b6c5$exports = {};
$948dffd8c072b6c5$exports = new URL("31.bed4a148.png", import.meta.url).toString();


var $fc4036c219465f79$exports = {};
$fc4036c219465f79$exports = new URL("32.0b9fa628.png", import.meta.url).toString();


var $6e43bd8486e3e894$exports = {};
$6e43bd8486e3e894$exports = new URL("33.b8130304.png", import.meta.url).toString();


var $a367724ec4945f5a$exports = {};
$a367724ec4945f5a$exports = new URL("34.44c0618f.png", import.meta.url).toString();


var $dddc4856fe6d4e33$exports = {};
$dddc4856fe6d4e33$exports = new URL("35.2c63ac43.png", import.meta.url).toString();


var $4b29a580c26a46bd$exports = {};
$4b29a580c26a46bd$exports = new URL("36.efe792db.png", import.meta.url).toString();


var $cdb261d4da38b690$exports = {};
$cdb261d4da38b690$exports = new URL("37.7e79ebd8.png", import.meta.url).toString();


var $e231aeceb53199c7$exports = {};
$e231aeceb53199c7$exports = new URL("38.bc3e4804.png", import.meta.url).toString();


var $2352fcd16b25a12f$exports = {};
$2352fcd16b25a12f$exports = new URL("39.91d3567c.png", import.meta.url).toString();


var $d0a2f5458c223bcb$exports = {};
$d0a2f5458c223bcb$exports = new URL("40.da18d44e.png", import.meta.url).toString();


var $e94eb12eea1571bc$exports = {};
$e94eb12eea1571bc$exports = new URL("41.416df1c7.png", import.meta.url).toString();


var $f0b4693c75a46c25$exports = {};
$f0b4693c75a46c25$exports = new URL("42.3a34dc1f.png", import.meta.url).toString();


var $b2acbcc8b8fb2bc7$exports = {};
$b2acbcc8b8fb2bc7$exports = new URL("43.5ba578ad.png", import.meta.url).toString();


var $02b06ca1fcc58f88$exports = {};
$02b06ca1fcc58f88$exports = new URL("44.05096ed2.png", import.meta.url).toString();


var $b4b7570360acf36c$exports = {};
$b4b7570360acf36c$exports = new URL("45.4037bc25.png", import.meta.url).toString();


var $063fe9ad9792cdd8$exports = {};
$063fe9ad9792cdd8$exports = new URL("46.d77eb262.png", import.meta.url).toString();


var $c37d4f1240bc6d3a$exports = {};
$c37d4f1240bc6d3a$exports = new URL("47.a3c5818a.png", import.meta.url).toString();


var $7f5d31b9b351d511$exports = {};
$7f5d31b9b351d511$exports = new URL("48.907e0e56.png", import.meta.url).toString();


var $2f090c411a3f5a10$exports = {};
$2f090c411a3f5a10$exports = new URL("49.53f70f63.png", import.meta.url).toString();


var $64c0b4275c174879$exports = {};
$64c0b4275c174879$exports = new URL("50.fcb823af.png", import.meta.url).toString();


var $3cf5f25001ae8514$exports = {};
$3cf5f25001ae8514$exports = new URL("51.5e0d2f66.png", import.meta.url).toString();


var $7d5d0bbeb9a8acd3$exports = {};
$7d5d0bbeb9a8acd3$exports = new URL("52.64ff298f.png", import.meta.url).toString();


var $09467127e149760f$exports = {};
$09467127e149760f$exports = new URL("53.0b398a42.png", import.meta.url).toString();


var $be35c2b00a10f478$exports = {};
$be35c2b00a10f478$exports = new URL("54.d728ffac.png", import.meta.url).toString();


var $ac52d11f62372d54$exports = {};
$ac52d11f62372d54$exports = new URL("55.153730f8.png", import.meta.url).toString();


var $b6b10b555492fd97$exports = {};
$b6b10b555492fd97$exports = new URL("56.b65ff898.png", import.meta.url).toString();


var $40fd5d66caeed321$exports = {};
$40fd5d66caeed321$exports = new URL("57.a7099aa7.png", import.meta.url).toString();


var $15817b73b23e834a$exports = {};
$15817b73b23e834a$exports = new URL("58.8fae3ad2.png", import.meta.url).toString();


var $dc0ef4450455466f$exports = {};
$dc0ef4450455466f$exports = new URL("59.1bd548ba.png", import.meta.url).toString();


var $4c8875c9654f9406$exports = {};
$4c8875c9654f9406$exports = new URL("60.65ae3232.png", import.meta.url).toString();


var $59911459a5187e98$exports = {};
$59911459a5187e98$exports = new URL("61.8dae416a.png", import.meta.url).toString();


var $69d854e066d2f9d0$exports = {};
$69d854e066d2f9d0$exports = new URL("62.b1fdfcff.png", import.meta.url).toString();


var $cb2be0630fee8b06$exports = {};
$cb2be0630fee8b06$exports = new URL("63.925d6784.png", import.meta.url).toString();


var $38ff94bcff036fb1$exports = {};
$38ff94bcff036fb1$exports = new URL("64.9783d915.png", import.meta.url).toString();


var $8f80f98e354b2bce$exports = {};
$8f80f98e354b2bce$exports = new URL("65.6b146544.png", import.meta.url).toString();


var $1e87e3407535fa5f$exports = {};
$1e87e3407535fa5f$exports = new URL("66.77e608a2.png", import.meta.url).toString();


var $081a0a5a70cc2791$exports = {};
$081a0a5a70cc2791$exports = new URL("67.ede302b3.png", import.meta.url).toString();


var $5dd32b11a33c8c2c$exports = {};
$5dd32b11a33c8c2c$exports = new URL("i0.9ebb77d9.png", import.meta.url).toString();


var $f5c2ac5d1636ce98$exports = {};
$f5c2ac5d1636ce98$exports = new URL("i1.5d533fa9.png", import.meta.url).toString();


var $a8441ba060f180ed$exports = {};
$a8441ba060f180ed$exports = new URL("i2.3e0a7ae3.png", import.meta.url).toString();


var $d2e34659ff168b67$exports = {};
$d2e34659ff168b67$exports = new URL("i4.08f436fc.png", import.meta.url).toString();


const $bd5736b37aff98b3$var$bopomofo = {
    1: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($cd17f8f7b228f5ad$exports))),
        name: "\u3105",
        value: "1"
    },
    2: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($1eb94315d280b418$exports))),
        name: "\u3106",
        value: "2"
    },
    3: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($f2912ec5cfa6e8ae$exports))),
        name: "\u3107",
        value: "3"
    },
    4: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($eaf669eb63be91b5$exports))),
        name: "\u3108",
        value: "4"
    },
    5: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($5887d3739f57db9f$exports))),
        name: '\u3105"',
        value: "5"
    },
    6: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($e86a9148c069d268$exports))),
        name: '\u3106"',
        value: "6"
    },
    7: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($bce268fba41a3d1a$exports))),
        name: '\u3107"',
        value: "7"
    },
    8: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($daf3bf220f8340fe$exports))),
        name: "\u3108f",
        value: "8"
    },
    9: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($ef1ec34a82d15ba0$exports))),
        name: "\u3108v",
        value: "9"
    },
    10: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($d01013695c865a60$exports))),
        name: "\u6469\u64E6\u3109",
        value: "10"
    },
    11: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($945c8cd5f1c78549$exports))),
        name: "\u6469\u64E6\u310A",
        value: "11"
    },
    12: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($30f88c6cad6edf48$exports))),
        name: "\u310B",
        value: "12"
    },
    13: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($7a38680b781c159a$exports))),
        name: "\u310C",
        value: "13"
    },
    14: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($a473f175886ac973$exports))),
        name: "\u3109^\u3117",
        value: "14"
    },
    15: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($fef5cadb447aaea8$exports))),
        name: "\u310A^\u3118",
        value: "15"
    },
    16: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($e084c2e42eb4e3bb$exports))),
        name: '\u3109"',
        value: "16"
    },
    17: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($ba8b68aeb0eb0313$exports))),
        name: '\u310A"',
        value: "17"
    },
    18: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($ef1d521155efbb18$exports))),
        name: "\u310B~",
        value: "18"
    },
    19: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($a40fc182aab17671$exports))),
        name: "\u310C~",
        value: "19"
    },
    20: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($edc9746367d9e7ed$exports))),
        name: "\u310C-",
        value: "20"
    },
    21: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($44f0c51ffb229d0c$exports))),
        name: "\u310D",
        value: "21"
    },
    22: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($bdd9029b7704941a$exports))),
        name: "\u310E",
        value: "22"
    },
    23: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($124caf38706a7b68$exports))),
        name: "\u310F",
        value: "23"
    },
    24: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($1007f69132666c34$exports))),
        name: '\u310D^"',
        value: "24"
    },
    25: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($dda08551c41d2872$exports))),
        name: '\u310E^"',
        value: "25"
    },
    26: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($61f5aad62f8b5191$exports))),
        name: "\u3110",
        value: "26"
    },
    27: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($112772afac2d1763$exports))),
        name: "\u3111",
        value: "27"
    },
    28: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($a31d927b9b9aa674$exports))),
        name: "\u3112",
        value: "28"
    },
    29: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($5d545cead6abf56d$exports))),
        name: "*\u3110*",
        value: "29"
    },
    30: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($5ce41163fe4d0f61$exports))),
        name: "*\u3111*",
        value: "30"
    },
    31: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($948dffd8c072b6c5$exports))),
        name: "*\u3112*",
        value: "31"
    },
    32: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($fc4036c219465f79$exports))),
        name: "\u3113",
        value: "32"
    },
    33: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($6e43bd8486e3e894$exports))),
        name: "\u3114",
        value: "33"
    },
    34: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($a367724ec4945f5a$exports))),
        name: "\u3115",
        value: "34"
    },
    35: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($dddc4856fe6d4e33$exports))),
        name: "\u3116",
        value: "35"
    },
    36: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($4b29a580c26a46bd$exports))),
        name: "\u3117",
        value: "36"
    },
    37: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($cdb261d4da38b690$exports))),
        name: "\u3118",
        value: "37"
    },
    38: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($e231aeceb53199c7$exports))),
        name: "\u3119",
        value: "38"
    },
    39: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($2352fcd16b25a12f$exports))),
        name: "Z",
        value: "39"
    },
    40: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($d0a2f5458c223bcb$exports))),
        name: "\u3119^\u0398",
        value: "40"
    },
    41: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($e94eb12eea1571bc$exports))),
        name: "Z^\u0398",
        value: "41"
    },
    42: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($f0b4693c75a46c25$exports))),
        name: "\u311A",
        value: "42"
    },
    43: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($b2acbcc8b8fb2bc7$exports))),
        name: "\u311B",
        value: "43"
    },
    44: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($02b06ca1fcc58f88$exports))),
        name: "\u311C",
        value: "44"
    },
    45: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($b4b7570360acf36c$exports))),
        name: "\u311D",
        value: "45"
    },
    46: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($063fe9ad9792cdd8$exports))),
        name: "\u5FC3\u311A",
        value: "46"
    },
    47: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($c37d4f1240bc6d3a$exports))),
        name: "\u3126",
        value: "47"
    },
    48: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($7f5d31b9b351d511$exports))),
        name: "\u3127^\u311D",
        value: "48"
    },
    49: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($2f090c411a3f5a10$exports))),
        name: "\u311A^\u311D",
        value: "49"
    },
    50: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($64c0b4275c174879$exports))),
        name: "\u3120^\u311D",
        value: "50"
    },
    51: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($3cf5f25001ae8514$exports))),
        name: "\u311E",
        value: "51"
    },
    52: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($7d5d0bbeb9a8acd3$exports))),
        name: "\u311F",
        value: "52"
    },
    53: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($09467127e149760f$exports))),
        name: "\u3120",
        value: "53"
    },
    54: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($be35c2b00a10f478$exports))),
        name: "\u3121",
        value: "54"
    },
    55: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($ac52d11f62372d54$exports))),
        name: "\u3122",
        value: "55"
    },
    56: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($b6b10b555492fd97$exports))),
        name: "\u3123",
        value: "56"
    },
    57: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($40fd5d66caeed321$exports))),
        name: "\u3124",
        value: "57"
    },
    58: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($15817b73b23e834a$exports))),
        name: "\u3125",
        value: "58"
    },
    59: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($dc0ef4450455466f$exports))),
        name: "\u3127",
        value: "59"
    },
    60: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($4c8875c9654f9406$exports))),
        name: "\u3128",
        value: "60"
    },
    61: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($59911459a5187e98$exports))),
        name: "\u3129",
        value: "61"
    },
    62: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($69d854e066d2f9d0$exports))),
        name: "\u311C^\u3127",
        value: "62"
    },
    63: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($cb2be0630fee8b06$exports))),
        name: "\u311C^\u3128",
        value: "63"
    },
    64: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($38ff94bcff036fb1$exports))),
        name: "\u3128^\u311C",
        value: "64"
    },
    65: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($8f80f98e354b2bce$exports))),
        name: "\u3128^i\u3113",
        value: "65"
    },
    66: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($1e87e3407535fa5f$exports))),
        name: "\u3127\u3127",
        value: "66"
    },
    67: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($081a0a5a70cc2791$exports))),
        name: "\u3118^\u0398",
        value: "67"
    },
    68: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($5dd32b11a33c8c2c$exports))),
        name: "\u8F15\u8072",
        value: "68"
    },
    69: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($f5c2ac5d1636ce98$exports))),
        name: "\u3127\u8072",
        value: "69"
    },
    70: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($a8441ba060f180ed$exports))),
        name: "\u4E8C\u8072",
        value: "70"
    },
    71: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($d2e34659ff168b67$exports))),
        name: "\u56DB\u8072",
        value: "71"
    }
};
var $bd5736b37aff98b3$export$2e2bcd8739ae039 = $bd5736b37aff98b3$var$bopomofo;


let $3ccc672aa8086c97$var$currentInputElement = null;
let $3ccc672aa8086c97$var$isKeyboardVisible = false;
function $3ccc672aa8086c97$export$9852ddb15aeb7ca3(container) {
    const keyboardWrapper = document.createElement("div");
    keyboardWrapper.id = "sor-keyboard-wrapper";
    keyboardWrapper.style.display = "none";
    const toggleButton = document.createElement("button");
    toggleButton.textContent = "\u986F\u793A/\u96B1\u85CF\u9375\u76E4";
    toggleButton.id = "toggle-keyboard-button";
    toggleButton.addEventListener("click", $3ccc672aa8086c97$var$toggleKeyboard);
    const keyboardContainer = document.createElement("div");
    keyboardContainer.id = "sor-keyboard";
    keyboardContainer.className = "keyboard-container";
    // 創建鍵盤佈局
    const keyboardLayout = [
        [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ],
        [
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22
        ],
        [
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33
        ],
        [
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44
        ],
        [
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55
        ],
        [
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67
        ],
        [
            68,
            69,
            70,
            71
        ],
        [
            "clear",
            "backspace"
        ]
    ];
    // 創建鍵盤
    keyboardLayout.forEach((row)=>{
        const rowElement = document.createElement("div");
        rowElement.className = "keyboard-row";
        row.forEach((key)=>{
            const keyElement = document.createElement("button");
            keyElement.className = "keyboard-key";
            keyElement.type = "button";
            if (key === "clear") {
                keyElement.textContent = "\u6E05\u9664";
                keyElement.classList.add("function-key", "clear-key");
                keyElement.addEventListener("click", $3ccc672aa8086c97$var$clearInput);
            } else if (key === "backspace") {
                keyElement.textContent = "\u522A\u9664";
                keyElement.classList.add("function-key", "backspace-key");
                keyElement.addEventListener("click", $3ccc672aa8086c97$var$backspace);
            } else {
                keyElement.dataset.value = (0, $bd5736b37aff98b3$export$2e2bcd8739ae039)[key].value;
                keyElement.dataset.image = (0, $bd5736b37aff98b3$export$2e2bcd8739ae039)[key].image;
                const imgElement = document.createElement("img");
                imgElement.src = (0, $bd5736b37aff98b3$export$2e2bcd8739ae039)[key].image;
                imgElement.alt = (0, $bd5736b37aff98b3$export$2e2bcd8739ae039)[key].name;
                imgElement.dataset.name = (0, $bd5736b37aff98b3$export$2e2bcd8739ae039)[key].name;
                imgElement.className = "keyboard-key-image";
                keyElement.appendChild(imgElement);
                keyElement.addEventListener("click", ()=>$3ccc672aa8086c97$var$addInputImage(keyElement.dataset.image, keyElement.dataset.value, (0, $bd5736b37aff98b3$export$2e2bcd8739ae039)[key].name));
            }
            rowElement.appendChild(keyElement);
        });
        keyboardContainer.appendChild(rowElement);
    });
    keyboardWrapper.appendChild(keyboardContainer);
    container.appendChild(toggleButton);
    container.appendChild(keyboardWrapper);
}
function $3ccc672aa8086c97$var$toggleKeyboard() {
    const keyboardWrapper = document.getElementById("sor-keyboard-wrapper");
    const toggleButton = document.getElementById("toggle-keyboard-button");
    if (!$3ccc672aa8086c97$var$currentInputElement || !$3ccc672aa8086c97$var$currentInputElement.isContentEditable) {
        alert("\u8ACB\u5148\u9078\u64C7\u4E00\u500B\u8F38\u5165\u6846");
        return;
    }
    $3ccc672aa8086c97$var$isKeyboardVisible = !$3ccc672aa8086c97$var$isKeyboardVisible;
    keyboardWrapper.style.display = $3ccc672aa8086c97$var$isKeyboardVisible ? "block" : "none";
    toggleButton.textContent = $3ccc672aa8086c97$var$isKeyboardVisible ? "\u96B1\u85CF\u9375\u76E4" : "\u986F\u793A\u9375\u76E4";
}
function $3ccc672aa8086c97$export$88f7b48baf778b50(inputElement) {
    $3ccc672aa8086c97$var$currentInputElement = inputElement;
}
function $3ccc672aa8086c97$var$addInputImage(imageSrc, value, name) {
    if (!$3ccc672aa8086c97$var$currentInputElement) {
        console.warn("No input element focused. Cannot add image.");
        return;
    }
    // Check if the current input element is contentEditable
    if (!$3ccc672aa8086c97$var$currentInputElement.isContentEditable) {
        console.warn("Current input element is not contentEditable. Cannot add image.");
        return;
    }
    const imgElement = document.createElement("img");
    imgElement.src = imageSrc;
    imgElement.alt = value;
    imgElement.dataset.name = name;
    imgElement.className = "input-image";
    imgElement.dataset.value = value;
    const selection = window.getSelection();
    const range = selection.getRangeAt(0);
    // Check if the range is within the current input element
    if (!$3ccc672aa8086c97$var$currentInputElement.contains(range.commonAncestorContainer)) {
        console.warn("Selection is outside the current input element. Focusing and moving cursor to the end.");
        $3ccc672aa8086c97$var$currentInputElement.focus();
        range.selectNodeContents($3ccc672aa8086c97$var$currentInputElement);
        range.collapse(false); // Move cursor to the end
    }
    range.deleteContents();
    range.insertNode(imgElement);
    range.setStartAfter(imgElement);
    range.setEndAfter(imgElement);
    selection.removeAllRanges();
    selection.addRange(range);
    $3ccc672aa8086c97$var$currentInputElement.focus();
    // Add this line to update the hidden input
    $3ccc672aa8086c97$var$updateHiddenInput($3ccc672aa8086c97$var$currentInputElement);
}
function $3ccc672aa8086c97$var$clearInput() {
    if (!$3ccc672aa8086c97$var$currentInputElement) return;
    $3ccc672aa8086c97$var$currentInputElement.innerHTML = "";
    $3ccc672aa8086c97$var$currentInputElement.focus();
}
function $3ccc672aa8086c97$var$backspace() {
    if (!$3ccc672aa8086c97$var$currentInputElement) return;
    const selection = window.getSelection();
    const range = selection.getRangeAt(0);
    if (range.collapsed) {
        const currentNode = range.startContainer;
        const offset = range.startOffset;
        if (currentNode === $3ccc672aa8086c97$var$currentInputElement && offset === 0) return;
        if (currentNode.nodeType === Node.TEXT_NODE) {
            if (offset > 0) {
                currentNode.textContent = currentNode.textContent.slice(0, offset - 1) + currentNode.textContent.slice(offset);
                range.setStart(currentNode, offset - 1);
                range.setEnd(currentNode, offset - 1);
            } else {
                const previousSibling = currentNode.previousSibling;
                if (previousSibling) {
                    if (previousSibling.nodeType === Node.TEXT_NODE) {
                        const newOffset = previousSibling.textContent.length;
                        previousSibling.textContent += currentNode.textContent;
                        currentNode.remove();
                        range.setStart(previousSibling, newOffset);
                        range.setEnd(previousSibling, newOffset);
                    } else previousSibling.remove();
                }
            }
        } else {
            const previousSibling = currentNode.childNodes[offset - 1];
            if (previousSibling) {
                previousSibling.remove();
                range.setStart(currentNode, offset - 1);
                range.setEnd(currentNode, offset - 1);
            }
        }
    } else range.deleteContents();
    selection.removeAllRanges();
    selection.addRange(range);
    $3ccc672aa8086c97$var$currentInputElement.focus();
    // Add this line to update the hidden input
    $3ccc672aa8086c97$var$updateHiddenInput($3ccc672aa8086c97$var$currentInputElement);
}
// Add this new function to update the hidden input
function $3ccc672aa8086c97$var$updateHiddenInput(inputElement) {
    const hiddenInputId = `hidden-${inputElement.id.split("-").pop()}`;
    const hiddenInput = document.getElementById(hiddenInputId);
    if (hiddenInput) {
        hiddenInput.value = $3ccc672aa8086c97$var$convertEditableDivContent(inputElement);
        console.log(`Updated hidden input ${hiddenInputId} with value: ${hiddenInput.value}`);
    } else console.warn(`Hidden input not found for ${inputElement.id}`);
}
// Update this function to connect multiple images with a period
function $3ccc672aa8086c97$var$convertEditableDivContent(editableDiv) {
    let result = [];
    let hasImage = false;
    editableDiv.childNodes.forEach((node)=>{
        if (node.nodeType === Node.TEXT_NODE) result.push(node.textContent.trim());
        else if (node.nodeName === "IMG") {
            hasImage = true;
            result.push(node.dataset.value || node.alt);
        } else if (node.nodeName === "BR") result.push("\n");
    });
    // If there are multiple images, join them with periods
    if (hasImage) return result.filter((item)=>item !== "").join(".");
    else return result.join("").trim();
}
function $3ccc672aa8086c97$export$e7a10d3883fd5a3a(inputElement) {
    let values = [];
    function extractFromNode(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.tagName === "IMG") {
                // 如果是圖片元素，提取 data-value 屬性
                const value = node.dataset.value;
                if (value) values.push(value);
            } else if (node.tagName === "BR") // 如果是換行元素，添加換行符
            values.push("\n");
            else // 遞歸處理其他元素的子節點
            Array.from(node.childNodes).forEach(extractFromNode);
        } else if (node.nodeType === Node.TEXT_NODE) // 如果是文本節點，直接添加文本內容
        values.push(node.textContent);
    }
    // 從根節點開始遞歸處理
    extractFromNode(inputElement);
    // 將所有值連接成一個字符串並返回
    return values.join("");
}


const $c0d87fb69e68bd07$var$commonSettings = {
    title: "\u856D\u535A\u58EBSoR\u7F8E\u8A9E\u6B63\u97F3\u5E2B\u300C\u807D\u529B\u7B46\u8A66\u6E2C\u9A57\uFF2A\u300D",
    description: [
        "\uFF08\u6E2C\u9A57\u8AAA\u660E\uFF09 \u672C\u6E2C\u9A57\u5171\u4E09\u90E8\u5206\uFF1A",
        "\u3010\u7B2C\u4E00\u90E8\u5206\u3011\u8ACB\u53C3\u7167\u300A\u81FA\u7063\u96D9\u8A9E\u6CE8\u97F3\u7B26\u865F\u8868\u300B\u4E26\u5728\u5C0D\u61C9\u984C\u865F\u4E2D\uFF0C\u5BEB\u51FA\u807D\u5230\u8072\u97F3\u7684\u7DE8\u865F\uFF08\u6BCF\u984C\u4E8C\u5206\uFF0C\u5171\u5341\u984C\uFF0C\u4F54\u4E8C\u5341\u5206\uFF09",
        "\u3010\u7B2C\u4E8C\u90E8\u5206\u3011\u8ACB\u53C3\u7167\u300A\u81FA\u7063\u96D9\u8A9E\u6CE8\u97F3\u7B26\u865F\u8868\u300B\u4E26\u5728\u5C0D\u61C9\u984C\u865F\u4E2D\uFF0C\u5BEB\u51FA\u97F3\u6A94\u6240\u5FF5CVC\u7D44\u5408\u8072\u97F3\u7684\u7DE8\u865F \uFF08\u6BCF\u984C\u4E09\u5206\uFF0C\u8A08\u5206\u65B9\u5F0F\u70BA\u5B50\u97F3\u4E00\u5206\uFF1B\u6BCD\u97F3\u5169\u5206\u6263\u5B8C\u70BA\u6B62\uFF0C\u5171\u4E8C\u5341\u4E94\u984C\uFF0C\u4F54\u4E03\u5341\u4E94\u5206\uFF09",
        "\u3010\u7B2C\u4E09\u90E8\u5206\u3011\u8ACB\u807D\u5B78\u54E1\u97F3\u6A94\uFF0C\u5148\u627E\u51FA\u5C0D\u65B9\u503C\u5F97\u9F13\u52F5\u7684\u90E8\u5206\uFF0C\u4E26\u5BEB\u51FA\u4E00\u9EDE\uFF0C\u8A72\u5B78\u54E1\u767C\u97F3\u6240\u7522\u751F\u660E\u986F\u7684\u504F\u79FB\u8AA4\u5DEE\uFF0C\u518D\u8A66\u7B54\uFF0C\u82E5\u60A8\u662F\u6B63\u97F3\u5E2B\u6703\u5982\u4F55\u5F15\u5C0E\u8207\u56DE\u8986\u3002\uFF08\u5171\u4E00\u984C\uFF0C\u4F54\u4E94\u5206\uFF09",
        "\uFF0A\u6CE8\u610F\u4E00\uFF1A\u672C\u6E2C\u9A57\u56DE\u7B54\u524D\u5169\u5927\u984C\u6642\uFF0C\u53EA\u9700\u586B\u5BEB\u807D\u5230\u8A72\u8072\u97F3\u7B26\u865F\u7684\u7DE8\u865F(\u975E\u586B\u7DE8\u865F\u4E0D\u8A08\u5206)",
        "\uFF0A\u6CE8\u610F\u4E8C\uFF1A\u56DE\u7B54\u7B2C\u4E8C\u90E8\u5206\u984C\u76EE\u6642\uFF0C\u8ACB\u6309\u7167CVC\u767C\u97F3\u5148\u5F8C\u9806\u5E8F\u586B\u5BEB\uFF0C\u4E26\u5728\u7DE8\u865F\u4E4B\u9593\u8ACB\u52A0\u4E0A\uFF08.\uFF09\u505A\u5340\u9694 ex: 13.53.22\u3002",
        "\uFF0A\u7E3D\u5206\u78BA\u8A8D\u5F8C\u5C07\u5BC4\u767C\u6210\u7E3E\u81F3\u672C\u8868\u55AE\u8A18\u9304\u4E4B\u4FE1\u7BB1\uFF0C\u8ACB\u52D9\u5FC5\u586B\u5BEB\u6B63\u78BA\u3002",
        "\uFF0A\u7E3D\u5206\u9700\u905490\u5206\u4EE5\u4E0A\uFF0C\u65B9\u9054\u5230\u6B63\u97F3\u5E2B\u7B46\u8A66\u53CA\u683C\u6A19\u6E96\u3002"
    ],
    endDescription: "\u7E3D\u5206\u78BA\u8A8D\u5F8C\u5C07\u5BC4\u767C\u6210\u7E3E\u81F3\u672C\u8868\u55AE\u8A18\u9304\u4E4B\u4FE1\u7BB1\uFF0C\u8ACB\u52D9\u5FC5\u586B\u5BEB\u6B63\u78BA\u3002",
    commonQuestion: [
        {
            id: "entry.172276031",
            questionTitle: "\u5E2B\u8CC7\u73ED\u5225",
            questionType: "radio",
            questionOptions: [
                "SoR\u5E2B\u8CC7\u3127\u73ED",
                "SoR\u5E2B\u8CC7\u4E8C\u73ED",
                "SoR\u5E2B\u8CC7\u4E09\u73ED",
                "SoR\u5E2B\u8CC7\u56DB\u73ED",
                "SoR\u5E2B\u8CC7\u4E94\u73ED",
                "SoR\u5E2B\u8CC7\u516D\u73ED",
                "SoR\u5E2B\u8CC7\u4E03\u73ED",
                "SoR\u5E2B\u8CC7\u516B\u73ED",
                "SoR\u5E2B\u8CC7\u4E5D\u73ED",
                "SoR\u5E2B\u8CC7\u5341\u73ED"
            ]
        },
        {
            id: "entry.573948846",
            questionTitle: "\u5E2B\u8CC7\u59D3\u540D",
            questionType: "text"
        },
        {
            id: "entry.2033835759",
            questionTitle: "\u8003\u8A66\u5E8F\u865F",
            questionDescription: "\u5982\u4E0A\u7DDA\u540D\u7A31\u70BA01-\u5B89\u8FEA\u54E5\uFF0C\u8ACB\u8F38\u516501",
            questionType: "text",
            inputType: "number"
        }
    ],
    googleFormResponseURL: "https://docs.google.com/forms/u/0/d/e/1FAIpQLSfpT12Ly2Be0AKOnnuAlsDwMVItwbYZaeXkT5C_XxSCccaR8A/formResponse"
};
const $c0d87fb69e68bd07$var$part1Settings = {
    title: "\u3010\u7B2C\u4E00\u90E8\u5206\u3011 \u807D\u51FA\u300A\u81FA\u7063\u96D9\u8A9E\u7B26\u865F\u8868\u300B\u500B\u5225\u7B26\u865F  \uFF08\u6BCF\u984C\u5169\u5206\uFF0C\u5171\u5341\u984C\uFF09",
    onlyCustomKeyboard: true,
    bopomofoKeyboard: true
};
const $c0d87fb69e68bd07$var$part1Questions = [
    {
        id: "entry.1062532100",
        questionTitle: "\u7B2C\u4E00\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.315045706",
        questionTitle: "\u7B2C\u4E8C\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.424153291",
        questionTitle: "\u7B2C\u4E09\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.886790481",
        questionTitle: "\u7B2C\u56DB\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.168045119",
        questionTitle: "\u7B2C\u4E94\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.757586012",
        questionTitle: "\u7B2C\u516D\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.2021541880",
        questionTitle: "\u7B2C\u4E03\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1791408647",
        questionTitle: "\u7B2C\u516B\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1922610091",
        questionTitle: "\u7B2C\u4E5D\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1452080461",
        questionTitle: "\u7B2C\u5341\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    }
];
const $c0d87fb69e68bd07$var$part2Settings = {
    title: "\u3010\u7B2C\u4E8C\u90E8\u5206\u3011 \u807D\u51FACVC\u7D44\u5408\u7684\u8072\u97F3\uFF08 \u6BCF\u984C\u4E09\u5206\uFF0C\u5171\u4E8C\u5341\u4E94\u984C\uFF09",
    description: "\u8ACB\u807D\u97F3\u6A94\uFF0C\u5728\u5C0D\u61C9\u984C\u865F\u4E2D\uFF0C\u4F9D\u5E8F\u5BEB\u51FACVC\u7D44\u5408\u7684\u8072\u97F3\u5728\u300A\u81FA\u7063\u96D9\u8A9E\u6CE8\u97F3\u7B26\u865F\u8868\u300B\u7684\u7DE8\u865F",
    onlyCustomKeyboard: true,
    bopomofoKeyboard: true
};
const $c0d87fb69e68bd07$var$part2Questions = [
    {
        id: "entry.129660470",
        questionTitle: "\u7B2C\u4E00\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.443571259",
        questionTitle: "\u7B2C\u4E8C\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.950072603",
        questionTitle: "\u7B2C\u4E09\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1691461409",
        questionTitle: "\u7B2C\u56DB\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1749489632",
        questionTitle: "\u7B2C\u4E94\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.2120291620",
        questionTitle: "\u7B2C\u516D\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.88536496",
        questionTitle: "\u7B2C\u4E03\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.743766707",
        questionTitle: "\u7B2C\u516B\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.325451342",
        questionTitle: "\u7B2C\u4E5D\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.602021393",
        questionTitle: "\u7B2C\u5341\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.480602353",
        questionTitle: "\u7B2C\u5341\u4E00\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.2082125563",
        questionTitle: "\u7B2C\u5341\u4E8C\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.204249988",
        questionTitle: "\u7B2C\u5341\u4E09\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.714185888",
        questionTitle: "\u7B2C\u5341\u56DB\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.505537057",
        questionTitle: "\u7B2C\u5341\u4E94\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1857846538",
        questionTitle: "\u7B2C\u5341\u516D\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.195684583",
        questionTitle: "\u7B2C\u5341\u4E03\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1248606910",
        questionTitle: "\u7B2C\u5341\u516B\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.621575898",
        questionTitle: "\u7B2C\u5341\u4E5D\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1219137104",
        questionTitle: "\u7B2C\u4E8C\u5341\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1817705071",
        questionTitle: "\u7B2C\u4E8C\u5341\u4E00\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1801778234",
        questionTitle: "\u7B2C\u4E8C\u5341\u4E8C\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.2144500851",
        questionTitle: "\u7B2C\u4E8C\u5341\u4E09\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1230447615",
        questionTitle: "\u7B2C\u4E8C\u5341\u56DB\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.358450166",
        questionTitle: "\u7B2C\u4E8C\u5341\u4E94\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    }
];
const $c0d87fb69e68bd07$var$part3Settings = {
    title: "\u3010\u7B2C\u4E09\u90E8\u5206\u3011\u5075\u932F\u7D66\u56DE\u994B \uFF08\u6BCF\u984C\u4E94\u5206\uFF0C\u5171\u4E00\u984C\uFF09",
    description: [
        "1.\u8ACB\u807D\u5B78\u54E1\u97F3\u6A94\uFF0C\u5148\u627E\u51FA\u5C0D\u65B9\u503C\u5F97\u9F13\u52F5\u7684\u90E8\u5206\uFF0C\u4E26\u76E1\u53EF\u80FD\u5BEB\u4E0B\u8A72\u5B78\u54E1\u767C\u97F3\u6240\u7522\u751F\u7684\u504F\u79FB\u554F\u984C",
        "2.\u518D\u8A66\u7B54\u82E5\u60A8\u662F\u6B63\u97F3\u5E2B\uFF0C\u6703\u5982\u4F55\u5F15\u5C0E\u8207\u56DE\u8986"
    ],
    bopomofoKeyboard: true
};
const $c0d87fb69e68bd07$var$part3Questions = [
    {
        id: "entry.164876408",
        questionTitle: "\u5075\u932F\u984C\uFF08\u3119\u3113\u3128\u311D stre\uFF09",
        questionDescription: "\u807D\u8A72\u5B78\u54E1\u97F3\u6A94\uFF0C\u7B54\u984C\u6642\u8ACB\u5148\u7C21\u77ED\u7CBE\u6E96\u5BEB\u51FA\u4E00\u9805\u60A8\u89C0\u5BDF\u5230\u5C0D\u65B9\u7684\u512A\u9EDE\uFF1B\u504F\u79FB\u90E8\u5206\u8ACB\u5BEB\u51FA\u4E3B\u8981\u5E0C\u671B\u5C0D\u65B9\u8ABF\u6574\u7684\u4E00\u9805\uFF0C\u4E26\u76E1\u53EF\u80FD\u689D\u5217\u8A73\u7B54\u5982\u4F55\u4E00\u6B65\u6B65\u5354\u52A9\u5C0D\u65B9\u8ABF\u97F3\u7684\u904E\u7A0B\u3002",
        questionHint: [
            "\u8B9A\u7F8E\u9F13\u52F5\u9EDE\uFF1A",
            "\u4E3B\u8981\u767C\u97F3\u554F\u984C\uFF1A",
            "\u8ABF\u6574\u65B9\u6CD5\uFF1A",
            "a.",
            "b.",
            "c.",
            "d."
        ],
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "textarea"
    }
];
const $c0d87fb69e68bd07$var$exportData = {
    settings: $c0d87fb69e68bd07$var$commonSettings,
    questions: [
        {
            settings: $c0d87fb69e68bd07$var$part1Settings,
            questions: $c0d87fb69e68bd07$var$part1Questions
        },
        {
            settings: $c0d87fb69e68bd07$var$part2Settings,
            questions: $c0d87fb69e68bd07$var$part2Questions
        },
        {
            settings: $c0d87fb69e68bd07$var$part3Settings,
            questions: $c0d87fb69e68bd07$var$part3Questions
        }
    ]
};
var $c0d87fb69e68bd07$export$2e2bcd8739ae039 = $c0d87fb69e68bd07$var$exportData;


function $1731529886db2b36$var$createTestHeader(settings) {
    const headerDiv = document.createElement("div");
    headerDiv.className = "test-header";
    const title = document.createElement("h1");
    title.textContent = settings.title;
    headerDiv.appendChild(title);
    const description = document.createElement("div");
    description.className = "test-description";
    description.innerHTML = settings.description.join("<br><br>");
    headerDiv.appendChild(description);
    return headerDiv;
}
function $1731529886db2b36$var$createEndDescription(settings) {
    const endDescription = document.createElement("div");
    endDescription.className = "end-description";
    endDescription.textContent = settings.endDescription;
    return endDescription;
}
function $1731529886db2b36$var$createTestContent(data) {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = (0, $c0d87fb69e68bd07$export$2e2bcd8739ae039).settings.googleFormResponseURL;
    form.className = "test-content";
    // Create common questions section
    const commonQuestionsSection = $1731529886db2b36$var$createCommonQuestionsSection(data.settings.commonQuestion);
    form.appendChild(commonQuestionsSection);
    // Create main questions sections
    data.questions.forEach((section)=>{
        const sectionDiv = $1731529886db2b36$var$createSection(section);
        form.appendChild(sectionDiv);
    });
    return form;
}
function $1731529886db2b36$var$createCommonQuestionsSection(commonQuestions) {
    const sectionDiv = document.createElement("div");
    sectionDiv.className = "common-questions-section";
    const sectionTitle = document.createElement("h2");
    sectionTitle.textContent = "\u57FA\u672C\u8CC7\u6599";
    sectionDiv.appendChild(sectionTitle);
    commonQuestions.forEach((question)=>{
        const questionDiv = $1731529886db2b36$var$createCommonQuestion(question);
        sectionDiv.appendChild(questionDiv);
    });
    return sectionDiv;
}
function $1731529886db2b36$var$createCommonQuestion(question) {
    const questionDiv = document.createElement("div");
    questionDiv.className = "common-question";
    const title = document.createElement("h3");
    title.textContent = question.questionTitle;
    questionDiv.appendChild(title);
    if (question.questionDescription) {
        const description = document.createElement("p");
        description.textContent = question.questionDescription;
        questionDiv.appendChild(description);
    }
    if (question.questionType === "radio" && Array.isArray(question.questionOptions)) {
        const optionsContainer = document.createElement("div");
        optionsContainer.className = "radio-options";
        question.questionOptions.forEach((option, index)=>{
            const label = document.createElement("label");
            const radio = document.createElement("input");
            radio.type = "radio";
            radio.name = `${question.id}`; // 確保名稱唯一
            radio.value = option;
            radio.id = `question-${question.id}-option-${index}`;
            label.htmlFor = radio.id; // 增加可訪問性
            label.appendChild(radio);
            label.appendChild(document.createTextNode(option));
            optionsContainer.appendChild(label);
        });
        questionDiv.appendChild(optionsContainer);
    } else if (question.questionType === "text") {
        // Add answer title
        const answerTitle = document.createElement("h4");
        answerTitle.textContent = "\u56DE\u7B54";
        questionDiv.appendChild(answerTitle);
        const input = document.createElement("input");
        input.type = "text";
        input.id = `question-${question.id}`;
        input.name = question.id; // Add name attribute
        questionDiv.appendChild(input);
    } else console.warn(`Unsupported question type: ${question.questionType}`);
    return questionDiv;
}
function $1731529886db2b36$var$createSection(section) {
    const sectionDiv = document.createElement("div");
    sectionDiv.className = "test-section";
    if (section.settings) {
        const sectionTitle = document.createElement("h2");
        sectionTitle.textContent = section.settings.title;
        sectionDiv.appendChild(sectionTitle);
        if (section.settings.description) {
            const sectionDescription = document.createElement("div");
            sectionDescription.className = "section-description";
            sectionDescription.innerHTML = Array.isArray(section.settings.description) ? section.settings.description.join("<br><br>") : section.settings.description;
            sectionDiv.appendChild(sectionDescription);
        }
        // Store the global onlyCustomKeyboard setting
        const globalOnlyCustomKeyboard = section.settings.onlyCustomKeyboard || false;
        // Store the global bopomofoKeyboard setting
        const globalBopomofoKeyboard = section.settings.bopomofoKeyboard || false;
        if (section.questions) section.questions.forEach((question)=>{
            // Apply global setting to each question if not explicitly set
            if (globalOnlyCustomKeyboard && question.onlyCustomKeyboard === undefined) question.onlyCustomKeyboard = true;
            if (globalBopomofoKeyboard && question.bopomofoKeyboard === undefined) question.bopomofoKeyboard = true;
            const questionDiv = $1731529886db2b36$var$createQuestion(question);
            sectionDiv.appendChild(questionDiv);
        });
    }
    return sectionDiv;
}
function $1731529886db2b36$var$createQuestion(question) {
    const questionDiv = document.createElement("div");
    questionDiv.className = "question";
    const title = document.createElement("h3");
    title.textContent = question.questionTitle;
    questionDiv.appendChild(title);
    const description = document.createElement("p");
    description.textContent = question.questionDescription;
    questionDiv.appendChild(description);
    if (question.questionHint) {
        const hintContainer = document.createElement("div");
        const hintTitle = document.createElement("div");
        hintTitle.className = "question-hint-title";
        hintTitle.textContent = "\u63D0\u793A";
        hintContainer.appendChild(hintTitle);
        hintContainer.className = "question-hint";
        question.questionHint.forEach((hint)=>{
            const hintParagraph = document.createElement("p");
            hintParagraph.textContent = hint;
            hintContainer.appendChild(hintParagraph);
        });
        questionDiv.appendChild(hintContainer);
    }
    if (question.questionType === "audio") {
        const audioTitle = document.createElement("h4");
        audioTitle.textContent = question.audioTitle || "\u984C\u76EE\u97F3\u6A94"; // 使用問題中的 audioTitle，如果沒有則默認為 '題目音檔'
        questionDiv.appendChild(audioTitle);
        const audio = document.createElement("audio");
        audio.controls = true;
        audio.src = question.questionAudio;
        questionDiv.appendChild(audio);
    }
    if (question.bopomofoKeyboard) {
        // Add answer title
        const answerTitle = document.createElement("h4");
        answerTitle.textContent = "\u56DE\u7B54";
        questionDiv.appendChild(answerTitle);
        const inputElement = document.createElement("div");
        inputElement.id = `sor-input-${question.id}`;
        inputElement.contentEditable = true;
        inputElement.className = question.inputType === "textarea" ? "editable-div" : "editable-input";
        inputElement.setAttribute("data-placeholder", "\u8ACB\u8F38\u5165\u6587\u5B57\u6216\u5C08\u5229\u6CE8\u97F3...");
        // Apply onlyCustomKeyboard setting
        if (question.onlyCustomKeyboard) {
            inputElement.setAttribute("data-placeholder", "\u8ACB\u900F\u904E\u5C08\u5229\u6CE8\u97F3\u56DE\u7B54...");
            inputElement.addEventListener("keydown", (e)=>{
                if (e.key !== "Tab") e.preventDefault();
            });
        }
        // Add focus event to set current input element
        inputElement.addEventListener("focus", ()=>(0, $3ccc672aa8086c97$export$88f7b48baf778b50)(inputElement));
        questionDiv.appendChild(inputElement);
        const hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = question.id;
        hiddenInput.id = `hidden-${question.id}`;
        questionDiv.appendChild(hiddenInput);
    } else {
        // Add answer title
        const answerTitle = document.createElement("h4");
        answerTitle.textContent = "\u56DE\u7B54";
        questionDiv.appendChild(answerTitle);
        // 如果沒有設置 bopomofoKeyboard，使用常規輸入
        const input = question.inputType === "textarea" ? document.createElement("textarea") : document.createElement("input");
        input.type = question.inputType === "text" ? "text" : question.inputType;
        input.id = `question-${question.id}`;
        input.name = question.id; // Add name attribute
        questionDiv.appendChild(input);
    }
    return questionDiv;
}
function $1731529886db2b36$var$createSubmitButton() {
    const submitButton = document.createElement("button");
    submitButton.textContent = "\u63D0\u4EA4\u7B54\u6848";
    submitButton.className = "submit-button";
    submitButton.type = "submit"; // 明確設置為 submit 類型
    return submitButton;
}
function $1731529886db2b36$var$createTestButton() {
    const testButton = document.createElement("button");
    testButton.textContent = "Test: Prefill Answers";
    testButton.className = "test-button";
    testButton.type = "button"; // 設置按鈕類型為 'button'
    testButton.addEventListener("click", $1731529886db2b36$var$prefillAnswers);
    return testButton;
}
function $1731529886db2b36$var$prefillAnswers() {
    // Prefill common questions
    const commonQuestions = document.querySelectorAll(".common-question");
    commonQuestions.forEach((questionDiv, index)=>{
        const input = questionDiv.querySelector('input[type="text"]');
        const radios = questionDiv.querySelectorAll('input[type="radio"]');
        if (input) input.value = `${index + 1}`;
        else if (radios.length > 0) radios[0].checked = true; // Select the first radio option
    });
    // Prefill main questions
    const mainQuestions = document.querySelectorAll(".question");
    mainQuestions.forEach((questionDiv, index)=>{
        const input = questionDiv.querySelector('input[type="text"], textarea');
        const editableDiv = questionDiv.querySelector("[contenteditable]");
        if (input) input.value = `${index + 1}`;
        else if (editableDiv) editableDiv.textContent = `${index + 1}`;
    });
    console.log("All answers have been prefilled for testing.");
}
document.addEventListener("DOMContentLoaded", ()=>{
    const container = document.querySelector(".container");
    // Create and append test header
    const testHeader = $1731529886db2b36$var$createTestHeader((0, $c0d87fb69e68bd07$export$2e2bcd8739ae039).settings);
    container.appendChild(testHeader);
    // Create and append test content (now a form)
    const testForm = $1731529886db2b36$var$createTestContent((0, $c0d87fb69e68bd07$export$2e2bcd8739ae039));
    container.appendChild(testForm);
    // Create and append end description
    const endDescription = $1731529886db2b36$var$createEndDescription((0, $c0d87fb69e68bd07$export$2e2bcd8739ae039).settings);
    container.appendChild(endDescription);
    // Add submit button to the form
    const submitButton = $1731529886db2b36$var$createSubmitButton();
    testForm.appendChild(submitButton);
    // Add test button for prefilling answers
    const testButton = $1731529886db2b36$var$createTestButton();
    container.appendChild(testButton);
    // Create and append the fixed SOR keyboard
    const keyboardContainer = document.createElement("div");
    keyboardContainer.id = "fixed-sor-keyboard";
    (0, $3ccc672aa8086c97$export$9852ddb15aeb7ca3)(keyboardContainer);
    container.appendChild(keyboardContainer);
    // 創建固定位置的容器來放置鍵盤和切換按鈕
    const fixedKeyboardContainer = document.createElement("div");
    fixedKeyboardContainer.id = "fixed-keyboard-container";
    (0, $3ccc672aa8086c97$export$9852ddb15aeb7ca3)(fixedKeyboardContainer);
    document.body.appendChild(fixedKeyboardContainer);
    // Add form submit event listener
    testForm.addEventListener("submit", function(event) {
        event.preventDefault();
        if ($1731529886db2b36$var$validateForm(this)) {
            console.log("Form is valid, submitting...");
            this.submit();
        } else console.log("Form validation failed");
    });
});
function $1731529886db2b36$var$validateForm(form) {
    const unansweredQuestions = [];
    // Validate all inputs
    form.querySelectorAll('input[type="text"], input[type="radio"], textarea, [contenteditable]').forEach((element)=>{
        let value;
        if (element.type === "radio") {
            const name = element.getAttribute("name");
            value = form.querySelector(`input[name="${name}"]:checked`) ? "checked" : "";
        } else if (element.hasAttribute("contenteditable")) value = $1731529886db2b36$var$convertEditableDivContent(element);
        else value = element.value.trim();
        if (!value) {
            const questionTitle = element.closest(".question, .common-question").querySelector("h3").textContent;
            unansweredQuestions.push(questionTitle);
        }
    });
    if (unansweredQuestions.length > 0) {
        alert(`\u{8ACB}\u{56DE}\u{7B54}\u{4EE5}\u{4E0B}\u{554F}\u{984C}\u{FF1A}
${unansweredQuestions.join("\n")}`);
        return false;
    }
    // Update hidden inputs for contenteditable elements
    form.querySelectorAll("[contenteditable]").forEach((element)=>{
        const hiddenInput = document.getElementById(`hidden-${element.id.split("-").pop()}`);
        if (hiddenInput) {
            hiddenInput.value = $1731529886db2b36$var$convertEditableDivContent(element);
            console.log(`Updated hidden input ${hiddenInput.id} with value: ${hiddenInput.value}`);
        } else console.warn(`Hidden input not found for ${element.id}`);
    });
    return true;
}
function $1731529886db2b36$var$convertEditableDivContent(editableDiv) {
    let result = [];
    let hasImage = false;
    editableDiv.childNodes.forEach((node)=>{
        if (node.nodeType === Node.TEXT_NODE) result.push(node.textContent.trim());
        else if (node.nodeName === "IMG") {
            hasImage = true;
            result.push(node.dataset.value || node.alt);
        } else if (node.nodeName === "BR") result.push("\n");
    });
    // If there are multiple images, join them with periods
    if (hasImage) return result.filter((item)=>item !== "").join(".");
    else return result.join("").trim();
}


//# sourceMappingURL=index.bdbb41a3.js.map
